import { render, staticRenderFns } from "./ReviewUsers.vue?vue&type=template&id=b8152944&"
import script from "./ReviewUsers.vue?vue&type=script&lang=js&"
export * from "./ReviewUsers.vue?vue&type=script&lang=js&"
import style0 from "./ReviewUsers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReviewUsers.vue"
export default component.exports